import { useState } from 'react';

import { prepareFilter } from 'libs/common';
import { Controller } from 'libs/control';
import { useSort } from 'libs/hooks';
import { RollbackGrid } from './grid';
import RollbackFilter from './filter';

export const Rollback = (props) => {
  const [items, setItems] = useState({});
  const [offset, setOffset] = useState(0);
  const [count, setCount] = useState(0);
  const [sortParams, setSortParams] = useSort('rollbacks', [{ field_name: 'start_at', direction: 'desc' }]);

  if (!items) {
    return <Loader2 theme={props.theme} />;
  }

  /**
   * prepare params
   * @param {*} data
   * @returns
   */
  const prepareParams = (data) => {
    if (!data) {
      data = {};
    }
    const intFields = ['id', 'amount', 'amount_from', 'amount_to'];
    const boolFields = ['status', 'result'];
    const addParams = {};

    if (data?.amount_from) {
      addParams.amount_from = 100 * parseFloat(data.amount_from);
    }
    if (data?.amount_to) {
      addParams.amount_to = 100 * parseFloat(data.amount_to);
    }

    return prepareFilter(data, addParams, { boolFields, intFields });
  };

  // grid actions
  const gridActions = {
    addEntries: (data) => setItems({ ...items, ...data }),
    clearEntries: () => setItems({}),
    updateEntry: (id, data) => {
      const newItems = { ...items };
      newItems[id] = { ...newItems[id], ...data };
      setItems(newItems);
    },
    setSortParams: (data) => setSortParams(data),
    setOffset: (val) => setOffset(val),
    setCount: (val) => setCount(val),
  };

  // grid params
  const gridParams = {
    entries: items,
    offset,
    count,
    sortParams,
  };

  return (
    <Controller
      {...props}
      {...gridParams}
      {...gridActions}
      type="refund"
      filterName="RollbackFilter"
      grid={RollbackGrid}
      gridFilter={RollbackFilter}
      getRequestParams={prepareParams}
    />
  );
};
